import { ImageListItem, ImageListItemBar, Skeleton, IconButton } from "@mui/material";
import ImageGallery from "../../../../../shared/ui/imageGallery.jsx";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { baseUrl, DOWNLOAD_FILE } from "../../../../../shared/api/endpoints.js";

/** Stable cards prevent layout shifts as lazy thumbnails arrive. */
export default function GalleryImageGrid({ allRows, lastInvoiceElement, setSelceted, choosable, setEditingData, setOpenEdit, loading }) {
  const rows = (allRows || []).filter((item) => item.hidden !== true);
  return <div className="gap-5 px-3 grid xl:grid-cols-7 lg:grid-cols-6 md:grid-cols-4 sm:grid-cols-3 grid-cols-2">
    {rows.map((item, index) => <ImageListItem key={item.id}
      ref={index === rows.length - 1 ? lastInvoiceElement : undefined}
      sx={{ height: "240px !important", minWidth: 0, overflow: "hidden" }}>
      <ImageGallery item={item} choosable={choosable} setSelceted={setSelceted} />
      <ImageListItemBar sx={{ textAlign: "left" }} title={<div className="flex justify-between">
        {item.id}<IconButton size="small" aria-label={"ویرایش تصویر " + item.id} onClick={() => {
          setEditingData(item); setOpenEdit(true);
        }}><MoreVertIcon sx={{ color: "white" }} /></IconButton>
      </div>} subtitle={<div className="flex flex-col gap-2">
        <div title={item.originalFileName}>نام عکس : {item.originalFileName}</div>
        <div>alt عکس : {item.alt}</div>
        <div>نوع ارتباط عکس : {item.source}</div>
        <div>{baseUrl}/{DOWNLOAD_FILE}/{item.id}</div>
      </div>} />
    </ImageListItem>)}
    {loading && Array.from({ length: rows.length ? 6 : 12 }, (_, index) =>
      <Skeleton key={"loading-" + index} variant="rectangular" height={240} width="100%" />)}
  </div>;
}
